import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import List from 'yoda-core-components/lib/components/List/List';
import config from 'yoda-core-components/lib/components/List/List/List.config';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductDetails from '../ProductDetails/ProductDetails';
import * as styles from './ProductDetailsList.css';

const cx = classNames.bind(styles);

function ProductDetailsList({
    shippingGroupDetails,
    orderAdjustments,
    orderGiftRegistries,
    currency,
}) {
    const productDetailsRenderer = (dataItem) => (
        <ProductDetails
            orderItem={dataItem}
            orderAdjustments={orderAdjustments}
            shippingType={shippingGroupDetails.type}
            orderGiftRegistries={orderGiftRegistries}
            currency={currency}
            shippingGroupDetails={shippingGroupDetails}
        />
    );
    return (
        <div data-automation-id="at-product-detail">
            <List
                direction={config.direction.VERTICAL}
                datasource={shippingGroupDetails.bagItems}
                childRenderer={productDetailsRenderer}
                listStyleClass={cx('listStyleWrapper')}
                itemStyleClass={dt([
                    'border-gray-15',
                    'border-solid',
                    'border-b',
                    '!px-6',
                    '!pt-6',
                    '!pb-3',
                ])}
                spacing="None"
            />
        </div>
    );
}

ProductDetailsList.defaultProps = {
    currency: 'USD',
};

ProductDetailsList.propTypes = {
    shippingGroupDetails: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string])
    ).isRequired,
    orderAdjustments: PropTypes.arrayOf(PropTypes.object).isRequired,
    orderGiftRegistries: PropTypes.objectOf(PropTypes.object).isRequired,
    currency: PropTypes.string,
};

export default ProductDetailsList;
